<template>
  <span>{{ flag }}</span>
</template>

<script>
import VueTypes from 'vue-types';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
export default {
  name: 'CountryFlag',
  props: {
    country: VueTypes.string.isRequired,
  },
  computed: {
    flag() {
      return this.country && getUnicodeFlagIcon(this.country);
    },
  },
};
</script>

<style lang="scss"></style>
